import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import breakpoint from 'styled-components-breakpoint';
import { ChannelActionButton } from 'components/atoms/buttons/ChannelActions';
import helpers from 'helpers';
import { CSVLink } from 'react-csv';
import { sanitizeCsvData } from 'helpers/sanitizeCsvData';

const TableCSVLink = styled(CSVLink)`
    margin: 0;
    padding: 0;
    text-decoration: none !important;

    &:hover, &:focus {
        text-decoration: none !important;
    }

`;

const ContentHeaderWrapper = styled.div`
    background-color: rgba(255, 255, 255, 0);
    display: flex;
    border-bottom: 1px solid #ccc;
    align-items: center;
    justify-content: space-between;
    line-height: 14px;
    margin-bottom: ${props => (props.type === 'chart' ? '8px' : '0px')};
    text-transform: uppercase;
    width: 100%;

    ${breakpoint('xs', 'sm')`
        justify-content: center;
    `}
`;

const ContentTitle = styled.div`
    font-weight: bold;
    font-size: 16px;
    /* color: ${props => props.theme.colors.bluemine}; */
    padding: 16px 0px;
    margin-left: 15px;

    ${breakpoint('xs', 'sm')`
        font-size: 14px;
    `}
`;

const ActionButtonWrapper = styled.div`
    margin-right: 45px;

    :last-child {
        margin-right: 15px;
    }

    ${breakpoint('xs', 'sm')`
        display: none;
    `}
`;

class ContentHeader extends Component {
    render() {
        const {
            hideCSVExport = false,
            type = null,
            tableData = [],
            exportName = null,
            allowExport = true
        } = this.props;

        const chartExportButton = <ChannelActionButton
            onClick={() => helpers.downloadChartCSV(this.props.chartRef) || (() => {})}
            hidden={hideCSVExport}
            fontSize={'12px'}
            icon={allowExport && 'icon-export'}
            iconSize={'13px'}
            text={allowExport && 'Export to CSV'}
            className="hidden-print"
            key='chart-csvlink'
        />;

        const tableExportButton =
            <TableCSVLink data={sanitizeCsvData(tableData)} hidden={hideCSVExport} key='table-csvlink' filename={`${exportName}.csv`}>
                <ChannelActionButton
                    fontSize={'12px'}
                    icon={allowExport && 'icon-export'}
                    iconSize={'13px'}
                    text={allowExport && 'Export to CSV'}
                    className="hidden-print"
                />
            </TableCSVLink>;

        const exportCSVButton = type === 'chart' ? chartExportButton : tableExportButton;
        const actionButtons = [exportCSVButton]; // more buttons will be added in the future
        return (
            <ContentHeaderWrapper type={this.props.type} >
                <ContentTitle>{this.props.children}</ContentTitle>
                <ActionButtonWrapper>{actionButtons.filter(button => !button.props.hidden)}</ActionButtonWrapper>
                {this.props.helpIcon}
            </ContentHeaderWrapper>
        );
    }
}

ContentHeader.propTypes = {
    marginBottom: PropTypes.string,
    helpIcon: PropTypes.node,
};

export default ContentHeader;



// WEBPACK FOOTER //
// ./src/components/atoms/layout/ContentHeader.js